import styled from 'styled-components';
import { Form } from 'antd';

export const Root = styled.div`
  margin: 0 auto;
  background: #fff;
  border-radius: 5px;
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  padding-bottom: 0.5rem;
`;

export const Title = styled.h3`
  font-family: "Open Sans";
  font-size: 24px;
  line-height: 30px;
  color: #000;
`;

export const Main = styled(Form)`
  padding-top: 2rem;
  border-top: 1px solid #e6e6e6;

  /* Semi-global styles */
  & .ant-form-item-control {
    margin-bottom: 0.4rem;
  }

  & .ant-form-item-label {
    padding: 0 0 4px;
    display: flex;
  }

  & .ant-form-item-label > label {
    height: 1.2rem;
  }

  & .ant-checkbox-wrapper {
    color: rgba(0, 0, 0, 0.85);
  }

  & .ant-form-item {
    margin-bottom: 7px;
  }
`;

export const Rows = styled.div`
  display: grid;
  grid-template-columns: 1fr;
`;

export const Row = styled.div`
  display: flex;
  width: 50%;
  flex-flow: column nowrap;
`;

export const Footer = styled.footer`
  margin: 1rem 0 0;
`;

export const ErrorMessage = styled.div`
  color: red;
`;

export const SuccessMessage = styled.div`
  color: #8c8c8c;
  margin: 0 0 10px;
`;

export const UserType = styled.div`
  color: #000;
  margin: 0 0 10px;
`;

export const SettingsContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const UserDropDown = styled.div`
  background: #e71313;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  height: 40px;
  width: 48px;
  border-radius: 5px;
  margin-right: 10px;

  .ant-icon {
    font-size: 12px;
  }
`;

export const HiddenContainer = styled.header`
  position: absolute;
  z-index: -999;
  opacity: 0;
`;
